import { Device } from "../Common/Types/types";
import httpClient from "../Core/http";

class WarrantiesAPi {
  getCustomerWarranties(params: any): Promise<any> {
    let url = "warranty/customer";
    return new Promise((resolve, reject) => {
      httpClient
        .get<any[]>(url, { params: params })
        .then((response: any) => {
          //console.log(response);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
          console.log(error);
        });
    });
  }
}

export const WarrantiesApi = new WarrantiesAPi();
